import { render, staticRenderFns } from "./ObjectRelatedAccessNotice.vue?vue&type=template&id=34615bbe&scoped=true&"
import script from "./ObjectRelatedAccessNotice.vue?vue&type=script&lang=js&"
export * from "./ObjectRelatedAccessNotice.vue?vue&type=script&lang=js&"
import style0 from "./ObjectRelatedAccessNotice.vue?vue&type=style&index=0&id=34615bbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34615bbe",
  null
  
)

export default component.exports